"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONTACT_BASED = exports.SEAT_BASED = exports.PORTAL_BASED = exports.FREE = void 0;
var FREE = 'FREE';
exports.FREE = FREE;
var PORTAL_BASED = 'PORTAL_BASED';
exports.PORTAL_BASED = PORTAL_BASED;
var SEAT_BASED = 'SEAT_BASED';
exports.SEAT_BASED = SEAT_BASED;
var CONTACT_BASED = 'CONTACT_BASED';
exports.CONTACT_BASED = CONTACT_BASED;